import Vue from 'vue';
import axios from 'axios'; // axios
import * as types from '../mutation-types';
import { DESTINATION_CHINA_ID } from '../../pages/config';

const state = {
  loading: {
    newscate: false,
    activitycate: false,
    kpcate: false,
    sexLabel: false,
  },
  newscateList: null,
  activitycateList: null,
  kpcateList: null,
  sexLabel: null,
};

const getters = {
  [types.BASE_LOAD.baseLoading]: (state, getters) => {
    return state.loading;
  },
  [types.BASE_LOAD.newscateList]: (state, getters) => {
    return state.newscateList || [];
  },
  [types.BASE_LOAD.activitycateList]: (state, getters) => {
    return state.activitycateList || [];
  },
  [types.BASE_LOAD.kpcateList]: (state, getters) => {
    return state.kpcateList || [];
  },
  [types.BASE_LOAD.sexLabel]: (state, getters) => {
    return {'01': '男', '02': '女', '03': '未知'};
  }
};

const mutations = {
  [types.BASE_LOAD.newscateList] (state, json) {
    state.newscateList = json;
    state.loading.newscate = false;
  },
  [types.BASE_LOAD.activitycateList] (state, json) {
    state.activitycateList = json;
    state.loading.activitycate = false;
  },
  [types.BASE_LOAD.kpcateList] (state, json) {
    state.kpcateList = json;
    state.loading.kpcate = false;
  },
}

const actions = {
  loadOthers({ dispatch, commit, state, rootState }, param) {
    if (!param.type || state.loading[param.type] === undefined) {
      param && param.callback && (param.callback.call(this, 'Missing type parameters!'));
    } else {
      param.params = Object.assign({}, param.params || {});
      dispatch('loadBase', { url: param.url, param: param });
    }
  },
  loadBase({ commit, state, rootState }, param) {
    let params = param.param;
    if (!state[params.list || params.obj] || (params.reload)) {
      state.loading[params.type] = true;
      //params.params.token = rootState.token;
      axios.get(param.url, {params: params.params, headers:{Authorization: rootState.token}})
        .then((response) => {
          const json = response.data;
          if (json && json[types.KEY_STATUS] === types.CODE_SUCCESS) {
            params.list
              ? commit(params.list, [])
              : commit(params.obj, {});
            if (json.obj) {
              params.list
                ? commit(params.list, json.obj)
                : commit(params.obj, json.obj);
            }
          } else {
            params && params.callback && (params.callback.call(this, json || '服务器错误！'));
            state.loading[params.type] = false;
          }
        })
        .catch((response) => {
          params && params.callback && (params.callback.call(this, response.data || '服务器错误！'));
          state.loading[params.type] = false;
        });
    }
  },
  [types.BASE_LOAD.newscateList] ({ dispatch, commit, state, rootState }, param = {}) {
    Object.assign(param, {type:'newscate', url:'sys/newscate/list', list:types.BASE_LOAD.newscateList});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.activitycateList] ({ dispatch, commit, state, rootState }, param = {}) {
    Object.assign(param, {type:'activitycate', url:'sys/activity/cate/list', list:types.BASE_LOAD.activitycateList});
    dispatch('loadOthers', param);
  },
  [types.BASE_LOAD.kpcateList] ({ dispatch, commit, state, rootState }, param = {}) {
    Object.assign(param, {type:'kpcate', url:'sys/kp/cate/list', list:types.BASE_LOAD.kpcateList});
    dispatch('loadOthers', param);
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
